// // // // // // // Default // // // // // // //
export const Akino = {
  Idle: require("../assets/navigation/default/Default_Akino_Idle.gif"),
  Run: require("../assets/navigation/default/Default_Akino_Run.gif"),
  Run_Super: require("../assets/navigation/default/Default_Akino_Run_Super.gif"),
};

export const Hiyori = {
  Idle: require("../assets/navigation/default/Default_Hiyori_Idle.gif"),
  Run: require("../assets/navigation/default/Default_Hiyori_Run.gif"),
  Run_Super: require("../assets/navigation/default/Default_Hiyori_Run_Super.gif"),
};

export const Kaori = {
  Idle: require("../assets/navigation/default/Default_Kaori_Idle.gif"),
  Run: require("../assets/navigation/default/Default_Kaori_Run.gif"),
  Run_Super: require("../assets/navigation/default/Default_Kaori_Run_Super.gif"),
};

export const Kasumi = {
  Idle: require("../assets/navigation/default/Default_Kasumi_Idle.gif"),
  Run: require("../assets/navigation/default/Default_Kasumi_Run.gif"),
  Run_Super: require("../assets/navigation/default/Default_Kasumi_Run_Super.gif"),
};

export const Nozomi = {
  Idle: require("../assets/navigation/default/Default_Nozomi_Idle.gif"),
  Run: require("../assets/navigation/default/Default_Nozomi_Run.gif"),
  Run_Super: require("../assets/navigation/default/Default_Nozomi_Run_Super.gif"),
};

export const Rei = {
  Idle: require("../assets/navigation/default/Default_Rei_Idle.gif"),
  Run: require("../assets/navigation/default/Default_Rei_Run.gif"),
  Run_Super: require("../assets/navigation/default/Default_Rei_Run_Super.gif"),
};

export const Suzuna = {
  Idle: require("../assets/navigation/default/Default_Suzuna_Idle.gif"),
  Run: require("../assets/navigation/default/Default_Suzuna_Run.gif"),
  Run_Super: require("../assets/navigation/default/Default_Suzuna_Run_Super.gif"),
};


// // // // // // // New Year // // // // // // //
export const New_Year_Hiyori = {
  Idle: require("../assets/navigation/new_year/New_Year_Hiyori_Idle.gif"),
  Run: require("../assets/navigation/new_year/New_Year_Hiyori_Run.gif"),
  Run_Super: require("../assets/navigation/new_year/New_Year_Hiyori_Run_Super.gif"),
};


// // // // // // // Summer // // // // // // //
export const Summer_Akino = {
  Idle: require("../assets/navigation/summer/Summer_Akino_Idle.gif"),
  Run: require("../assets/navigation/summer/Summer_Akino_Run.gif"),
  Run_Super: require("../assets/navigation/summer/Summer_Akino_Run_Super.gif"),
};

export const Summer_Hiyori = {
  Idle: require("../assets/navigation/summer/Summer_Hiyori_Idle.gif"),
  Run: require("../assets/navigation/summer/Summer_Hiyori_Run.gif"),
  Run_Super: require("../assets/navigation/summer/Summer_Hiyori_Run_Super.gif"),
};

export const Summer_Kaori = {
  Idle: require("../assets/navigation/summer/Summer_Kaori_Idle.gif"),
  Run: require("../assets/navigation/summer/Summer_Kaori_Run.gif"),
  Run_Super: require("../assets/navigation/summer/Summer_Kaori_Run_Super.gif"),
};

export const Summer_Kasumi = {
  Idle: require("../assets/navigation/summer/Summer_Kasumi_Idle.gif"),
  Run: require("../assets/navigation/summer/Summer_Kasumi_Run.gif"),
  Run_Super: require("../assets/navigation/summer/Summer_Kasumi_Run_Super.gif"),
};

export const Summer_Nozomi = {
  Idle: require("../assets/navigation/summer/Summer_Nozomi_Idle.gif"),
  Run: require("../assets/navigation/summer/Summer_Nozomi_Run.gif"),
  Run_Super: require("../assets/navigation/summer/Summer_Nozomi_Run_Super.gif"),
};

export const Summer_Rei = {
  Idle: require("../assets/navigation/summer/Summer_Rei_Idle.gif"),
  Run: require("../assets/navigation/summer/Summer_Rei_Run.gif"),
  Run_Super: require("../assets/navigation/summer/Summer_Rei_Run_Super.gif"),
};

export const Summer_Suzuna = {
  Idle: require("../assets/navigation/summer/Summer_Suzuna_Idle.gif"),
  Run: require("../assets/navigation/summer/Summer_Suzuna_Run.gif"),
  Run_Super: require("../assets/navigation/summer/Summer_Suzuna_Run_Super.gif"),
};


// // // // // // // Halloween // // // // // // //
export const Halloween_Kaori = {
  Idle: require("../assets/navigation/halloween/Halloween_Kaori_Idle.gif"),
  Run: require("../assets/navigation/halloween/Halloween_Kaori_Run.gif"),
  Run_Super: require("../assets/navigation/halloween/Halloween_Kaori_Run_Super.gif"),
};


// // // // // // // Christmas // // // // // // //
export const Christmas_Akino = {
  Idle: require("../assets/navigation/christmas/Christmas_Akino_Idle.gif"),
  Run: require("../assets/navigation/christmas/Christmas_Akino_Run.gif"),
  Run_Super: require("../assets/navigation/christmas/Christmas_Akino_Run_Super.gif"),
};
